<template>
	<thead class="thead">
		<tr>
			<th>
				<div class="item">Date</div>
			</th>
			<th :key="item.date" v-for="item in dateList" colspan="13">{{ item.date }}</th>
		</tr>
		<tr>
			<th>
				<div class="item">Time</div>
			</th>
			<template v-for="(item, idx) in dateList">
				<th :key="time + idx" v-for="time in item.time">
					<div class="item">{{ time }}</div>
				</th>
			</template>
		</tr>
	</thead>
</template>

<script>
export default {
	name: "PlanerHeader",
	props: {
		dateList: Array
	}
};
</script>

<style scoped lang="scss">
@import "PlanerHeader";
</style>
